export default {"src":"/_next/static/media/Document-big-full.ae6ebe9f.svg","height":1019,"width":904};